angular.module('rjmNg.directives').directive "allConnections", [
  "$url"
  ($url) ->
    restrict: "E"
    templateUrl: 'settings/directive.allConnections.html'
    replace: true
    scope: {}
    controllerAs: "view"
    require: "^?rjmUi"
    bindToController: true
    controller: [
      "$routeParams"
      "Clients"
      "app"
      "InputConnections"
      "CONNECTIONS"
      "logger"
      "appRoute"
      "notification"
      (
        $routeParams
        Clients
        app
        InputConnections
        CONNECTIONS
        logger
        appRoute
        notification
      ) ->

        view = @

        clientId = $routeParams.clientId
        InputConnectionsInstance = InputConnections(clientId)

        view.isAdminUser = app.isAdminUser()
        view.isLoading =
          pdw: false
          uploads: false

        ## view urls
        view.addConnectionsUrl = appRoute "/settings/connection/add"

        view.hasDataSourceConnection = true

        view.isImplemented = true # to prevent flashing view on page load to clients who are implemented

        view.isDisabledIntegrationsUi = app.hasFeatureFlag('DISABLE_INTEGRATIONS_UI')

        if view.isDisabledIntegrationsUi
          notification.clear("all-connections")
          notification.warning(
            "Warning",
            "Ability to add or edit integrations is temporarily unavailable. \
            Please refer to the \
            <a href=\"https://status.adobe.com/products/3350/\" target=\"_blank\">\
            Adobe status</a> page for more information.",
            "all-connections",
            {dismissable: false}
          )

        Clients.get(clientId)
        .then (clientInfo) -> 
          view.isImplemented = clientInfo.properties.is_implemented

        InputConnectionsInstance.get()
        .then (connections) ->
          view.hasDataSourceConnection = _.some connections, (connection) ->
            connection.type isnt CONNECTIONS.TYPES.USER_PUSH

        view.logButtonClick = (name) ->
          logger.log('Connections Page Usage', 'Open', 1, 'edit')

        view

    ]
    link: (scope, element, attributes, rjmUi) ->

      scope.$watchCollection "view.isLoading", (newVal, oldVal) ->
        wasPageLoading = Object.keys(oldVal).some((key) -> oldVal[key])
        isPageLoading = Object.keys(newVal).some((key) -> newVal[key])
        ## Prevents loadingUi function from being called excessively
        if wasPageLoading isnt isPageLoading
          rjmUi?.loadingUi "all-connections", isPageLoading, "Loading your integrations"
  ]
